import DialogContent, { DialogContentProps } from '@material-ui/core/DialogContent';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import * as React from 'react';

interface ISMDialogContentProps extends DialogContentProps {
  disablePadding?: boolean;
  disableOverflow?: boolean;
  children?: React.ReactNode;
}

const useStyles = makeStyles<Theme, Omit<ISMDialogContentProps, 'children'>>(
  createStyles({
    content: props => ({
      overflow: props.disableOverflow ? 'hidden' : undefined,
      padding: props.disablePadding ? '0 !important' : undefined
    })
  })
);

let SMDialogContent: React.ComponentType<ISMDialogContentProps> = ({ children, ...props }) => {
  const classes = useStyles(props);
  return <DialogContent className={classes.content}>{children}</DialogContent>;
};

SMDialogContent = React.memo<ISMDialogContentProps>(SMDialogContent);
export { SMDialogContent };
